import { Icon, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { useBgHover } from "../../themes/colors";
import { typeLogin } from "../../utils/etc";

interface Props {
  onClick: (id: any, link: string) => void;
}

export const ListLoginTypeCard = ({ onClick, ...rest }: Props) => {
  const bgHover = useBgHover();

  return (
    <SimpleGrid w={"100%"} columns={[1, 3, 3, 3, 3]} gap={4} {...rest}>
      {typeLogin.map((item, i) => (
        <VStack
          key={item.id}
          px={[4, null, 10]}
          py={6}
          borderWidth={"1px"}
          borderRadius={"md"}
          borderColor={"gray.300"}
          onClick={() => {
            onClick(item.id, item.link);
          }}
          _hover={{
            bgColor: bgHover,
          }}
          cursor={"pointer"}
        >
          <Icon as={item.icon} fontSize={[20, null, 30]} />

          <Text textStyle={"b-sm"}>{item.title}</Text>
        </VStack>
      ))}
    </SimpleGrid>
  );
};
